import sistemaBNCCService from "./SistemaBNCCService";
import alunosService from "./AlunosService";
import anosService from "./AnosService";
import authService from "./AuthService";
import caixasService from "./CaixasService";
import franquiasService from "./FranquiasService";
import matriculasService from "./MatriculasService";
import formasDePagamentoService from "./FormasDePagamentoService";
import parcelasService from "./ParcelasService";
import turmasService from "./TurmasService";
import turnosService from "./TurnosService";
import seriesService from "./SeriesService";
import cursosService from "./CursosService";
import cepService from "./CepService";
import disciplinasService from "./DisciplinasService";
import professoresService from "./ProfessoresService";
import usuariosService from "./UsuariosService";
import inepService from "./InepService";
import gestoesDeAulasService from "./GestoesDeAulasService";
import planosBimestraisService from "./PlanosBimestraisService";
import aulasService from "./AulasService";
import notasService from "./NotasService";
import relatoriosService from "./RelatoriosService";
import tiposDeEnsinosService from "./TiposDeEnsinosService";
import responsavelAlunoService from "./ResponsavelAlunoService";
import avisosService from "./AvisosService";
import imageService from "./ImageService";
import agendasService from "./AgendaService";
import rolesService from "./RolesService";
import notifiqService from "./NotifiqService";
import webInfo from "./WebInfo";
import informativosService from "./InformativosService";
import circuitoNotasService from "./CircuitoNotasService";
import etapasService from "./EtapasService";
import subEtapasService from "./SubEtapasService";
import regrasService from "./RegrasService";
import calendarioLetivoService from "./CalendarioLetivoService";
import eventoCalendarioLetivoService from "./EventoCalendarioLetivoService";
import autorizacoesService from "./AutorizacoesService";
import historicoService from "./HistoricoService";

const $services = {
  alunosService,
  anosService,
  authService,
  caixasService,
  franquiasService,
  matriculasService,
  formasDePagamentoService,
  parcelasService,
  turmasService,
  turnosService,
  seriesService,
  cursosService,
  cepService,
  disciplinasService,
  professoresService,
  usuariosService,
  inepService,
  gestoesDeAulasService,
  planosBimestraisService,
  aulasService,
  notasService,
  relatoriosService,
  sistemaBNCCService,
  tiposDeEnsinosService,
  rolesService,
  responsavelAlunoService,
  avisosService,
  imageService,
  agendasService,
  notifiqService,
  webInfo,
  informativosService,
  circuitoNotasService,
  etapasService,
  subEtapasService,
  regrasService,
  calendarioLetivoService,
  eventoCalendarioLetivoService,
  autorizacoesService,
  historicoService,
};

export default $services;
